import React from 'react'
import './BifrostHero.scss'

export class BifrostHero extends React.Component {
  render() {
    return (
      <div
        className="bifrost-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>Bifrost</h1>
            <h2>Open-Source CI/CD Pipeline Catalog for DoD DevSecOps</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default BifrostHero
